const hexRegex = /^#([A-Fa-f0-9]{3,4}){1,2}$/;
/**
 * Function to validate hexcode
 * @example
 * import { isValidHex } from '@design-stack-vista/i18n-color-name';
 *
 * if (isValidHex('#000000')) {
 *     // write your code here
 * }
 * @param {string} hex
 * @returns {boolean}
 */
export const isValidHex = (hex) => hexRegex.test(hex);
export const getChunksFromString = (hexStr, chunkSize) => hexStr.match(new RegExp(`.{${chunkSize}}`, 'g'));
export const convertHexUnitTo256 = (hexStr) => parseInt(hexStr.repeat(2 / hexStr.length), 16);
// Get alpha for opacity
export const getAlpha = (a, alpha = 1) => {
    if (typeof a !== 'undefined') {
        return a / 255;
    }
    if (alpha < 0 || alpha > 1) {
        return 1;
    }
    return alpha;
};
/**
 * Convert hex code value in RGB and return red, green and blue
 * @example
 * import { hexToRGBA } from '@design-stack-vista/i18n-color-name';
 *
 * const { r, g, b, a, value } = hexToRGBA('#000000');
 * @param {string} hex
 * @param {number} alpha
 * @returns {object}
 */
export const hexToRGBA = (hex, alpha) => {
    if (!isValidHex(hex)) {
        throw new Error('unknown hex code.');
    }
    const chunkSize = Math.floor((hex.length - 1) / 3);
    const hexArr = getChunksFromString(hex.slice(1), chunkSize);
    const [r, g, b, a] = hexArr.map(convertHexUnitTo256);
    if (!a || !alpha) {
        return { r, g, b, value: `rgb(${r}, ${g}, ${b})` };
    }
    const deltaA = getAlpha(a, alpha);
    return { r, g, b, a: deltaA, value: `rgba(${r}, ${g}, ${b}, ${deltaA})` };
};
//# sourceMappingURL=hex.js.map